import SettingsIcon from '@mui/icons-material/Settings';

export const AdminIcon = SettingsIcon;
